import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { installModuleLoadRecovery } from "./lib/moduleRecovery";

installModuleLoadRecovery();

// Register the service worker so the app qualifies as an installable PWA.
// Skip in Lovable preview/dev iframes to avoid stale caches.
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  const host = window.location.hostname;
  const isPreview =
    host.startsWith("id-preview--") ||
    host.startsWith("preview--") ||
    host.endsWith(".lovableproject.com") ||
    host.endsWith(".lovableproject-dev.com") ||
    host === "lovableproject.com";
  const inIframe = window.self !== window.top;
  if (!isPreview && !inIframe) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw-push.js").catch((e) => console.warn("SW register failed", e));
    });
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
